/**
 * The two Croatian datetime formats. They differ, and mixing them is one of the
 * easiest bugs to ship — see the warning in TECHNICAL_PLAN.md §5.4.
 *
 *   ZKI      dd.MM.yyyy HH:mm:ss   (space separator)
 *   XML      dd.MM.yyyyTHH:mm:ss   (literal T)
 *   QR       yyyyMMdd_HHmm
 *
 * All three are rendered in Europe/Zagreb local time. The reference
 * implementation hand-rolled DST against Europe/Berlin, which works by luck
 * (§5.11 defect 8); we use Intl with an explicit zone.
 */
export const ZAGREB = "Europe/Zagreb";
const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: ZAGREB,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
});
function zagrebParts(date) {
    if (Number.isNaN(date.getTime()))
        throw new Error("Invalid Date passed to a Zagreb formatter");
    const out = {};
    for (const p of formatter.formatToParts(date)) {
        if (p.type !== "literal")
            out[p.type] = p.value;
    }
    // Intl renders midnight as "24" in some ICU versions; normalise.
    if (out.hour === "24")
        out.hour = "00";
    return out;
}
/** `dd.MM.yyyy HH:mm:ss` — the ZKI datetime. Note the SPACE, not a T. */
export function formatZkiDateTime(date) {
    const p = zagrebParts(date);
    return `${p.day}.${p.month}.${p.year} ${p.hour}:${p.minute}:${p.second}`;
}
/** `dd.MM.yyyyTHH:mm:ss` — the XML <DatVrijeme> / <DatumVrijeme>. Note the T. */
export function formatXmlDateTime(date) {
    const p = zagrebParts(date);
    return `${p.day}.${p.month}.${p.year}T${p.hour}:${p.minute}:${p.second}`;
}
/** `yyyyMMdd_HHmm` — the QR `datv` parameter (§5.8). */
export function formatQrDateTime(date) {
    const p = zagrebParts(date);
    return `${p.year}${p.month}${p.day}_${p.hour}${p.minute}`;
}
/** `dd.MM.yyyy` — used by the working-hours message and UI display. */
export function formatDate(date) {
    const p = zagrebParts(date);
    return `${p.day}.${p.month}.${p.year}`;
}
//# sourceMappingURL=datetime.js.map